import React, { useState } from 'react'
import Carousel, { Modal, ModalGateway } from 'react-images'
import {
  CFImage,
  CFLink,
  CFSelect,
  CFView,
  DefaultScreen,
  LocationSelect,
  MobileScreen,
} from 'components'
import { headerBg, logo, mobileLogo, logoTitle, viewMenu } from 'images'
import ViewMenuButton from './ViewMenuButton'
import { dispatch } from 'store'

const orderingUrl =
  process.env.REACT_APP_ENVIRONMENT === 'dev'
    ? 'https://demo.codefusion.tech/restaurants/ebisu/locations/ebisuLocation1'
    : 'https://order.codefusion.tech/restaurants/8GFwb8UTNOQ2rbtqc9kk/locations/Y7GXtSFgqD6z5v9Jpd8q'

const images = []

export default () => {
  const [showModal, setShowModal] = useState(false)

  return (
    <>
      <MobileScreen>
        <CFView column center w="100%" bg="rgba(0,0,0,0.9)" textCenter>
          <CFView style={{ fontSize: 31 }} white xBold p="5px">
            Sushi Iwa White Rock
          </CFView>
        </CFView>
      </MobileScreen>
      <DefaultScreen>
        <CFView
          column
          center
          w="100%"
          zIndex={98}
          h="60px"
          bg="rgba(0,0,0,0.9)"
        >
          <CFView row justifyBetween alignCenter w="100%" maxWidth="1400px">
            <CFView style={{ fontSize: 31 }} white xBold ml="15px">
              Sushi Iwa White Rock
            </CFView>
            <CFView mt="10px">
              <ViewMenuButton />
            </CFView>
          </CFView>
        </CFView>
      </DefaultScreen>
      <ModalGateway>
        {showModal ? (
          <Modal onClose={() => setShowModal(false)}>
            <Carousel views={images} />
          </Modal>
        ) : null}
      </ModalGateway>
    </>
  )
}
